import { ExcelTool } from '../../core/excel/excel_tool';
import { FileUploadDialog } from '../../core/fileupload/FileUploadDialog';
import { importLastgang } from './routinen/importLastgang';
import { LineDiagram } from '../datenauswertung/helper/lineChart';
import * as Moment from 'moment';
import * as React from 'react';
import style from '../../default.less';
import { WFormFieldDateTime } from '../../core/forms/WFormFramework';
import { WSimpleTupelList } from '../../core/lists/WSimpleTupelList';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
import { ZusatztoolsLastgaengeTabelle } from './ZusatztoolsLastgaengeTabelle';

export interface ZusatztoolsLastgaengeProps {
    data: any;
    standortSelected: any;
}

export interface ZusatztoolsLastgaengeState {
    isLoaded: boolean;
    lastgangData: Array<any>;
    showSpinner: boolean;
    stampFrom: number;
    stampMax: number;
    stampMin: number;
    stampTo: number;
}

export class ZusatztoolsLastgaenge extends React.Component<ZusatztoolsLastgaengeProps, ZusatztoolsLastgaengeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isLoaded: false,
            lastgangData: undefined,
            showSpinner: false,
            stampFrom: undefined,
            stampMax: undefined,
            stampMin: undefined,
            stampTo: undefined
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
    }

    onValueChange(name: string, value: any): void {
        console.log({ name }, { value });
        if (name === 'stampFrom') {
            window.setTimeout(() => this.setState({ stampFrom: value * 1000 }), 100);
        } else if (name === 'stampTo') {
            window.setTimeout(() => this.setState({ stampTo: value * 1000 }), 100);
        }
    }

    render(): JSX.Element {
        /*
        return (
            <div
            style={{ textAlign: 'center', padding: '20px' }}
        >
            <div className={style.infofield}>
                Lastgang aus Excel importieren
                <FileUploadDialog
                    onDataLoaded={this.onDataLoaded}
                    onDataSelected={() => this.setState({ showSpinner: true })}
                />
            </div>
            {this.state.isLoaded && this.renderErgebnis()}
            {this.state.showSpinner && <WSpinner/>}
        </div>
        );
        */
        return (
            <div>
                <ZusatztoolsLastgaengeTabelle
                    data={this.props.data}
                    standortSelected={this.props.standortSelected}
                />
            </div>
        );
    }

    renderControls(): JSX.Element {
        return (
            <div className={style.rowContainer}>
                <div style={{ marginLeft: 3 }}>
                    <WFormFieldDateTime
                        label={
                            <div style={{ width: 250, fontSize: '11px', backgroundColor: '#ddd', padding: 3 }}>
                                Anzeige (von)</div>
                        }
                        name={'stampFrom'}
                        value={this.state.stampFrom / 1000}
                        minDate={new Date(this.state.stampMin)}
                        maxDate={new Date(this.state.stampTo)}
                        withTimePicker={false}
                        onValueChange={this.onValueChange}
                        required={true}
                    />
                </div>
                <div style={{ marginLeft: 3 }}>
                    <WFormFieldDateTime
                        label={<div style={{ width: 250, fontSize: 11, backgroundColor: '#ddd', padding: 3 }}>
                            Anzeige (bis)</div>}
                        name={'stampTo'}
                        value={this.state.stampTo / 1000}
                        minDate={new Date(this.state.stampFrom)}
                        maxDate={new Date(this.state.stampMax)}
                        withTimePicker={false}
                        onValueChange={this.onValueChange}
                        required={true}
                    />
                </div>
            </div>
        );
    }

    renderErgebnis(): JSX.Element {
        console.log('State', this.state);
        return (
            <div>
                <div className={style.rowContainer}>
                    <div style={{ width: '250px', fontSize: '11px', padding: 3 }}>
                        <div style={{ backgroundColor: '#ddd', padding: 3 }}>Datum von</div>
                        <div>{Moment(this.state.stampMin).format('DD.MM.YY')}</div>
                    </div>
                    <div style={{ width: 250, fontSize: '11px', padding: 3 }}>
                        <div style={{ backgroundColor: '#ddd', padding: 3 }}>Datum bis</div>
                        <div>{Moment(this.state.stampMax).format('DD.MM.YY')}</div>
                    </div>
                </div>
                {this.renderControls()}
                <div>
                    {this.renderList()}
                </div>
            </div>
        );
    }

    renderList(): JSX.Element {
        const start = new Date().getTime();
        const data = this.state.lastgangData;
        const stampFrom = this.state.stampFrom;
        const stampTo = this.state.stampTo;
        // Später noch Filtern
        const matchLimit = 1000;

        const tupel_all = data.filter((item: any) => {
            const stamp = item.datetime.getTime();
            const match = stamp >= stampFrom && stamp <= stampTo;
            return match;
        }).map((item: any) => {
            return {
                name: Moment(item.datetime).format('DD.MM.YY HH:mm'),
                jahr: Moment(item.datetime).format('DD.MM.YY HH:mm'), // Für das Diagramm
                value: item.value
            };
        });
        const tupel = tupel_all.filter((item: any, idx) => idx < 1000);
        const cnt_total = data.length;
        const cnt_show = tupel.length;
        const list = (
            <WSimpleTupelList
                data={tupel}
                widthName={150}
                widthValue={150}
            />
        );
        const end = new Date().getTime();
        console.log('render-time:', (end - start) / 1000);
        return (
            <div
                className={style.rowContainer}
            >
                <div style={{ width: 350 }}>
                    <div style={{ fontSize: '11px', backgroundColor: '#ddd', padding: 3 }}>
                        Es werden {cnt_show} von {cnt_total} Datensätzen angezeigt
                    </div>
                    <div style={{ maxHeight: '400px', overflow: 'auto', fontSize: '10px' }}>
                        {list}
                    </div>
                </div>
                <div className={style.diagramm} style={{ maxHeight: 400 }}>
                    <LineDiagram
                        data={tupel}
                        visibleData={['value']}
                        legendTitle={[<span>Lastgang</span>]}
                        unit={['kW']}
                        createNewTick={true}
                    />
                </div>
            </div>
        );
    }

    private onDataLoaded(dataLoaded: string): void {
        // Excel-Datei zunächst mit XLSX parsen
        const excel = new ExcelTool();
        const workbook = excel.getWorkbook(dataLoaded);
        let lastgangData = importLastgang(excel, workbook);
        let stampMin = undefined;
        let stampMax = undefined;
        // console.log('Lg', lastgangData);
        if (lastgangData.length > 0) {
            lastgangData = lastgangData.filter((row: any) => row !== undefined);
            stampMin = lastgangData[0].datetime.getTime();
            stampMax = lastgangData[lastgangData.length - 1].datetime.getTime();
        }
        this.setState({
            isLoaded: true,
            showSpinner: false,
            lastgangData,
            stampMin,
            stampMax,
            stampFrom: stampMin,
            stampTo: stampMax
        });
    }
}
